import { Grid, GridProps } from "@react-three/drei";
import { useLayoutEffect, useRef } from "react";
import * as THREE from "three";

export const GreenGrid = ({ position, ...props }: { position?: [number, number, number] } & GridProps) => {
  const gridRef = useRef<THREE.Mesh>(null!);

  useLayoutEffect(() => {
    //@ts-ignore
    gridRef.current.material.depthWrite = false;
    //@ts-ignore
    gridRef.current.material.transparent = true;
    //@ts-ignore
    gridRef.current.material.blending = THREE.AdditiveBlending;
  }, []);

  return (
    <>
      <Grid
        ref={gridRef}
        position={position}
        cellSize={0.025}
        sectionSize={0.125}
        cellColor="#004100"
        cellThickness={1}
        sectionColor="#015501"
        sectionThickness={1.5}
        fadeDistance={3}
        fadeStrength={7}
        infiniteGrid
        {...props}
      />
    </>
  );
};
